import { RootState } from '@store';

export const selectPimVehicleList = (state: RootState) => {
  return state.pimVehicleList?.pimVehicleList;
};
